import React, { useState } from 'react';
import EditAccountSettings from './EditAccountSettings';
import ChangePassword from './ChangePassword.js';

function AccountSettings() {
  const [showEditAccountDetails, setShowEditAccountDetails] = useState(true);
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <div>
      <div className="help-container d-flex flex-column justify-content-center align-items-center vh-100">
        <div className="password-form">
          <EditAccountSettings />
        </div>
      </div>

    </div>
  );
}

export default AccountSettings;
